export default "__VITE_ASSET__39dfc902__"